<script>
    import { sgettext } from '../../i18n.js';
	import { buildUrl } from '../../utils.js';
    import { PATH_PREFIX } from '../../apiUrls.js';    
    import { dashBoardWorkCentreId } from './dashBoardStrore.js';
	import { checked, labelWithCount } from './HomePage.svelte';
    import D2InstructionTable from './D2InstructionTable.svelte';
    import LeftRightBox from './LeftRightBox.svelte';
    import Tabs from '../Tabs/Tabs.svelte';
    import Tab from '../Tabs/Tab.svelte';
    import TabPanel from '../Tabs/TabPanel.svelte';
    import TabBar from '../Tabs/TabBar.svelte';

    export let branch = 'BHP';
    export let branchId = 1;
    export let workCentreId = 0;

    $: workCentreId;

	let stats = {};
	const fetchCounts = async (params) => {
		stats = await (await fetch(buildUrl(`${PATH_PREFIX}/sw/api/d2_instruction_stats`, params))).json();
	}

	$: fetchCounts({branch: branchId, checked: $checked, workCentreId: $dashBoardWorkCentreId});

</script>

<Tabs className="subtabs" persistKey="homepage-instructions">
  <LeftRightBox>
    <label slot="left">{sgettext('$$D2_INSTRUCTION_PDFS$$')}</label>
    <TabBar slot="right">
      <Tab
        key="all"
        tabKey="all"
        label={sgettext('$$ALL$$') + (stats.total != null ? ` (${stats.total})` : '')}
        component={D2InstructionTable}
        {branchId}
        {branch}
      />
      <Tab
        key="published"
        tabKey="published"
        label={sgettext('$$PUBLISHED$$') + (stats.published != null ? ` (${stats.published})` : '')}
        component={D2InstructionTable}
        {branchId}
        {branch}
      />
      <Tab
        key="failed"
        tabKey="failed"
        label={sgettext('$$FAILED$$') + (stats.failed != null ? ` (${stats.failed})` : '')}
        component={D2InstructionTable}
        {branchId}
        {branch}
      />
    </TabBar>
  </LeftRightBox>
  <TabPanel />
</Tabs>
